import Layout from '@/layout'

const PillReportRouter = {
  path: '/PillReport',
  component: Layout,
  redirect: 'noredirect',
  name: 'PillReport',
  meta: {
    title: 'PILL财务数据报表',
    icon: 'daohang-tongjifenxi',
    roles: []
  },
  children: [
    {
      path: 'ReportSetting',
      component: import('@/views/cargo/v0/PillReport/ReportSetting'),
      name: 'ReportSetting',
      meta: { title: 'Report Setting' },
      roles: ['module_ReportSetting']
    },
    {
      path: 'FinanceExport',
      component: import('@/views/cargo/v0/PillReport/FinanceExport'),
      name: 'FinanceExport',
      meta: { title: 'Finance Export' },
      roles: ['module_FinanceExport']
    },
    {
      path: 'HrExport',
      component: import('@/views/cargo/v0/PillReport/HrExport'),
      name: 'HrExport',
      meta: { title: 'HR Export' },
      roles: ['module_HrExport']
    },
    {
      path: 'FinanceReport',
      component: import('@/views/cargo/v0/PillReport/FinanceReport'),
      name: 'FinanceReport',
      meta: { title: 'Finance Report' },
      roles: ['module_FinanceReport']
    }
  ]
}

export default PillReportRouter
